import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ServiceChannel, ServiceChannelInput} from './service-channel.model';

export const loadServiceChannels = createAction(
  '[ServiceChannel/API] Load ServiceChannels',
  props<{ serviceChannels: ServiceChannel[] }>()
);

export const addServiceChannel = createAction(
  '[ServiceChannel/API] Add ServiceChannel',
  props<{ serviceChannel: ServiceChannel }>()
);

export const upsertServiceChannel = createAction(
  '[ServiceChannel/API] Upsert ServiceChannel',
  props<{ serviceChannel: ServiceChannel }>()
);

export const addServiceChannels = createAction(
  '[ServiceChannel/API] Add ServiceChannels',
  props<{ serviceChannels: ServiceChannel[] }>()
);

export const upsertServiceChannels = createAction(
  '[ServiceChannel/API] Upsert ServiceChannels',
  props<{ serviceChannels: ServiceChannel[] }>()
);

export const updateServiceChannel = createAction(
  '[ServiceChannel/API] Update ServiceChannel',
  props<{ serviceChannel: Update<ServiceChannel> }>()
);

export const updateServiceChannels = createAction(
  '[ServiceChannel/API] Update ServiceChannels',
  props<{ serviceChannels: Update<ServiceChannel>[] }>()
);

export const deleteServiceChannel = createAction(
  '[ServiceChannel/API] Delete ServiceChannel',
  props<{ id: string }>()
);

export const deleteServiceChannels = createAction(
  '[ServiceChannel/API] Delete ServiceChannels',
  props<{ ids: string[] }>()
);

export const clearServiceChannels = createAction(
  '[ServiceChannel/API] Clear ServiceChannels'
);

// CUSTOM
export const createServiceChannel = createAction(
  '[ServiceChannel/API] create ServiceChannel',
  props<{ input: ServiceChannelInput }>()
);


export const getServiceChannel = createAction(
  '[ServiceChannel/API] get all ServiceChannels',
  props<{ serviceUniqueId: string }>()
);


export const removeServiceChannel = createAction(
  '[ServiceChannel/API] remove ServiceChannel',
  props<{ channelUniqueId: string, id: string }>()
);
